import { forwardRef } from 'react'
import ButtonHOC from 'platform/react/hoc/button'
import Section from 'ui/Element/Section'

const SectionAsButton = ButtonHOC(forwardRef(Section))

export default SectionAsButton
